import { createListenerMiddleware, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'

import { RootState } from '@/store'
import { ThunkExtra } from '@/store/actions'
import { setWidgets } from '@/store/dashboard-widgets/slice'
import { getWidgetData } from '@/store/dashboard-widgets/thunks'

const instance = createListenerMiddleware<
  RootState,
  ThunkDispatch<RootState, ThunkExtra, UnknownAction>
>()

instance.startListening({
  actionCreator: setWidgets,
  effect: (_, listenerApi) => {
    listenerApi.cancelActiveListeners()
    const state = listenerApi.getState()
    const widgets = state.dashboardWidgets.widgets
    widgets.forEach((widget) => {
      listenerApi.dispatch(getWidgetData({ widget }) as unknown as UnknownAction)
    })
  },
})

export const dashboardWidgetsMiddleware = instance.middleware
